import { useContext } from 'react'

import { Box, Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { PageTitle } from '@scoir/headers'

import useTitle from 'common/use-title'
import ParentHandraisers from 'components/IntegrationConfiguration/ParentHandraisers'
import { useAppSelector } from 'store'
import { isHandraisersEnabled } from 'store/feature-toggle'

import ConfigureIntegration from './ConfigureIntegration'
import Documents from './Documents'
import Handraisers from './Handraisers'
import IntegrationConfigurationProvider from './IntegrationConfigurationProvider'
import IntegrationConfigurationContext from './IntegrationConfigurationProvider/Context'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(3),
  },
}))

const IntegrationConfiguration = () => {
  const classes = useStyles()
  const handraisersEnabled = useAppSelector(isHandraisersEnabled)

  const { state } = useContext(IntegrationConfigurationContext)

  return (
    <Container maxWidth="md">
      <PageTitle
        titleProps={{ component: 'h1' }}
        title="SFTP Configuration"
        subTitle="One SFTP configuration supports both handraisers data and document delivery"
      />
      {state.isLoading ? null : (
        <Box className={classes.container}>
          <Box className={classes.paper}>
            <ConfigureIntegration />
          </Box>
          <Box className={classes.paper}>
            <Documents />
          </Box>
          {handraisersEnabled && (
            <Box className={classes.paper}>
              <Handraisers />
            </Box>
          )}
          <ParentHandraisers />
        </Box>
      )}
    </Container>
  )
}

const IntegrationConfigurationWrapper = () => {
  useTitle(`Scoir - SFTP Configuration`)
  return (
    <IntegrationConfigurationProvider>
      <IntegrationConfiguration />
    </IntegrationConfigurationProvider>
  )
}
export default IntegrationConfigurationWrapper
